import React from 'react';
import { Button, Tooltip, ButtonProps, TooltipProps } from '@mui/material';

type ConditionalTooltipButtonProps = {
  isDisabled: boolean;
  button: JSX.Element;
  tooltipProps: Pick<TooltipProps, 'title' | 'placement'>;
};
export const ConditionalTooltipButton = (
  props: ConditionalTooltipButtonProps,
) => {
  const { tooltipProps, button, isDisabled } = props;

  if (isDisabled) {
    const disabledButton = React.cloneElement(button, {
      disabled: true,
      href: '',
    });
    return (
      <Tooltip {...tooltipProps}>
        <span>{disabledButton}</span>
      </Tooltip>
    );
  }
  return button;
};
